// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"5d96a06b","440":"0dd307e9","506":"227b866a","511":"3ac36e0c","512":"1f6324ec","561":"767581b7","690":"e8f95da1","722":"554a84fe","850":"040fb37b","910":"3b064210"}[chunkId] + ".chunk.js";
};